module.exports = __webpack_public_path__ + "static/media/beer.039e6315.svg";